import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Col } from 'antd';

import { useLibertyMutualSubStepsContext } from '../../../context';
import { Topic, Value } from '../styles';

export const LineName = () => {
	const {
		libertyMutualResult: {
			informations: { line_name }
		}
	} = useLibertyMutualSubStepsContext();

	return (
		<Col xs={24}>
			<Topic>{I18n.get('Line')}:</Topic>
			<Value>{line_name}</Value>
		</Col>
	);
};
